export default {
  'warehouse.title.list': '倉庫目錄',
  'warehouse.title.add': '新增倉庫',
  'warehouse.title.edit': '更改倉庫',
  'warehouse.title.delete': '刪除倉庫',
  'warehouse.message.delete': '確認刪除倉庫?',
  'warehouse.field.name': '倉別名稱',
}
